
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg-icon",classNames,staticClass],
              style: [{"width":"1em","height":"1em","vertical-align":"middle"},style,staticStyle],
              attrs: Object.assign({"style":"width:1em;height:1em;vertical-align:middle","viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","overflow":"hidden"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M825.1 924H198.8c-12.1 0-21.8-9.8-21.8-21.8 0-12.1 9.8-21.8 21.8-21.8h626.3c30.4 0 55.1-24.7 55.1-55.1V539.4c0-12.1 9.8-21.8 21.8-21.8 12.1 0 21.8 9.8 21.8 21.8v285.9c0 54.4-44.3 98.7-98.7 98.7zM433.5 612.8h-.8c-6.1-.2-11.8-3-15.7-7.6L241.1 400.6c-7.9-9.1-6.8-22.9 2.3-30.8 9.1-7.9 22.9-6.8 30.8 2.3l160.5 186.8L887.4 106c8.5-8.5 22.4-8.5 30.9 0s8.5 22.4 0 30.9L448.9 606.4c-4.1 4.1-9.6 6.4-15.4 6.4z"}}),_c('path',{attrs:{"d":"M716.5 815.6H197.4c-54.5 0-98.8-44.3-98.8-98.8v-.3l6.9-518.9c.1-54.4 44.4-98.6 98.8-98.6h475.3c12.1 0 21.8 9.8 21.8 21.8 0 12.1-9.8 21.8-21.8 21.8H204.3c-30.4 0-55.1 24.7-55.1 55.1v.3l-6.9 518.9c.1 30.3 24.8 55 55.1 55h519.1c30.4 0 55.1-24.7 55.1-55.1V418.4c0-12.1 9.8-21.8 21.8-21.8 12.1 0 21.8 9.8 21.8 21.8v298.4c0 54.5-44.3 98.8-98.7 98.8z"}})])
          )
        }
      }
    